import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';

export function ElectionListSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {[1, 2, 3, 4].map(i => (
        <Card key={i}>
          <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="40%" height={28} />
              <Skeleton variant="text" width="60%" height={20} sx={{ mt: 0.5 }} />
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Skeleton variant="rounded" width={70} height={24} />
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

export function ElectionDetailSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Skeleton variant="rounded" width={70} height={24} />
          <Skeleton variant="text" width={200} height={20} />
        </Box>
        <Skeleton variant="rounded" width={140} height={36} />
      </Box>

      <Box
        sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }, gap: 2 }}
      >
        {[1, 2, 3, 4].map(i => (
          <Card key={i}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Skeleton variant="circular" width={20} height={20} />
                <Skeleton variant="text" width={80} height={20} />
              </Box>
              <Skeleton variant="text" width="80%" height={24} />
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="70%" height={24} />
            </CardContent>
          </Card>
        ))}
      </Box>

      <Box>
        <Skeleton variant="rounded" width="100%" height={48} sx={{ mb: 2 }} />
        <Card>
          <CardContent>
            <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
            <Skeleton variant="text" width="100%" height={20} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="70%" height={20} />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export function VoterTableSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Skeleton variant="rounded" width={80} height={24} />
          <Skeleton variant="rounded" width={100} height={24} />
          <Skeleton variant="rounded" width={90} height={24} />
        </Box>
        <Skeleton variant="rounded" width={100} height={36} />
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <Skeleton variant="rounded" width="100%" height={40} sx={{ flex: 1 }} />
        <Skeleton variant="rounded" width={140} height={40} />
        <Skeleton variant="rounded" width={140} height={40} />
        <Skeleton variant="rounded" width={120} height={40} />
      </Box>

      <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: 1.5,
            borderBottom: 1,
            borderColor: 'divider'
          }}
        >
          <Skeleton variant="rectangular" width={20} height={20} sx={{ mr: 2 }} />
          <Skeleton variant="text" width="15%" height={20} sx={{ mr: 2 }} />
          <Skeleton variant="text" width="25%" height={20} sx={{ mr: 2 }} />
          <Skeleton variant="text" width="10%" height={20} sx={{ mr: 2 }} />
          <Skeleton variant="text" width="15%" height={20} sx={{ mr: 2 }} />
          <Skeleton variant="text" width="10%" height={20} />
        </Box>
        {[1, 2, 3, 4, 5].map(i => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: 1.5,
              borderBottom: 1,
              borderColor: 'divider'
            }}
          >
            <Skeleton variant="rectangular" width={20} height={20} sx={{ mr: 2 }} />
            <Skeleton variant="text" width="15%" height={20} sx={{ mr: 2 }} />
            <Skeleton variant="text" width="25%" height={20} sx={{ mr: 2 }} />
            <Skeleton variant="rounded" width={60} height={22} sx={{ mr: 2 }} />
            <Box sx={{ display: 'flex', gap: 0.5, mr: 2 }}>
              <Skeleton variant="rounded" width={50} height={22} />
              <Skeleton variant="rounded" width={50} height={22} />
            </Box>
            <Skeleton variant="rounded" width={80} height={22} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export function UserElectionCardSkeleton() {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <Skeleton variant="text" width="50%" height={28} />
              <Skeleton variant="rounded" width={60} height={24} />
            </Box>
            <Skeleton variant="text" width="80%" height={20} />
            <Box sx={{ display: 'flex', gap: 3, mt: 2 }}>
              <Box>
                <Skeleton variant="text" width={80} height={16} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
              <Box>
                <Skeleton variant="text" width={80} height={16} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
            <Skeleton variant="rounded" width={140} height={36} />
            <Skeleton variant="rounded" width={180} height={32} />
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export function MyElectionsSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Skeleton variant="rounded" width="100%" height={56} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rounded" width={300} height={40} />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {[1, 2, 3].map(i => (
          <UserElectionCardSkeleton key={i} />
        ))}
      </Box>
    </Box>
  );
}

export function CreateElectionSkeleton() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Skeleton variant="circular" width={32} height={32} />
        <Box>
          <Skeleton variant="text" width={200} height={32} />
          <Skeleton variant="text" width={280} height={20} />
        </Box>
      </Box>

      <Card>
        <CardContent>
          <Skeleton variant="text" width={100} height={28} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width={250} height={20} sx={{ mb: 3 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Skeleton variant="rounded" width="100%" height={56} />
            <Skeleton variant="rounded" width="100%" height={100} />

            <Box
              sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}
            >
              <Skeleton variant="rounded" width="100%" height={56} />
              <Skeleton variant="rounded" width="100%" height={56} />
            </Box>

            <Box
              sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}
            >
              <Skeleton variant="rounded" width="100%" height={56} />
              <Skeleton variant="rounded" width="100%" height={56} />
            </Box>

            <Skeleton variant="rounded" width="100%" height={56} />
            <Skeleton variant="rounded" width="100%" height={56} />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
              <Skeleton variant="rounded" width={100} height={36} />
              <Skeleton variant="rounded" width={130} height={36} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
